module.exports = __webpack_public_path__ + "img/zip.47d086ce.svg";